import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  header: {
    position: "relative",
    top: 0,
    backgroundColor: "#fff",
    color: "#000",
    padding: "0 !important",
    display: "flex",
    flexDirection: "column",
    boxShadow: "none",
    minHeight: "80px",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      minHeight: "135px",
    },
  },
  logo: {
    position: "absolute",
    top: "0",
    left: "50%",
    transform: "translate(-50%, 0)",
    "& img": {
      aspectRatio: "1",
      objectFit: "contain",
      objectPosition: "center",
      maxWidth: "80px",
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      top: "0.75rem",
      left: "0.35rem",
      transform: "none",
      zIndex: "inherit",
      "& img": {
        maxWidth: "135px",
      },
    },
  },
  topMenu: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    background: "#0073aa",
    padding: "0.5rem 0.875rem",
    borderBottom: "3px solid",
    borderImage:
      "linear-gradient(to right, rgb(0, 133, 195), rgb(0, 87, 128)) 1",
    minHeight: "28px",
  },
  topMenuItem: {
    color: "#fff",
    margin: "0 10px",
    fontSize: "14px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      color: "#e2f6ff",
    },
  },
  middle: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0.5rem 0.75rem",
  },
  secondMenu: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
  },
  menuItemSecondary: {
    fontWeight: "bold",
    color: (props) => (props.theme === "light" ? "#00963F" : "#15bb5b"),
    fontSize: "11.5px",
    textDecoration: "none",
    textTransform: "uppercase",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  socialMenu: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 0",
    gap: "1rem",
  },
  socialIcon: {
    color: (props) => (props.theme === "light" ? "#004d40" : "#0fa188"),
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
  },
  mainMenu: {
    minHeight: "30px",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    borderTop: "3px solid",
    color: "#ffffff",
    padding: "0.5rem 1.5rem",
    borderImage: "linear-gradient(to right, #86E98D, #46B419) 1",
    background: "linear-gradient(90deg, #00963f 0%, #0d60da 100%)",
  },
  mainMenuMobile: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "3px solid",
    color: "#ffffff",
    padding: "0.5rem 1.5rem",
    borderImage: "linear-gradient(to right, #86E98D, #46B419) 1",
    background: "linear-gradient(90deg, #00963f 0%, #0d60da 100%)",
  },
  menuItem: {
    fontSize: "14px",
    marginLeft: "1rem",
    fontWeight: "bold",
    color: "#ffffff",
    textDecoration: "none",
    textTransform: "uppercase",
    padding: "0",
    cursor: "pointer",
    "&:hover": {
      color: "inherit",
      mixBlendMode: "difference",
    },
  },
  drawerList: {
    width: 250,
  },
  contextDivider: {
    margin: "0 2rem",
    height: "1.5rem",
    color: "#00000060",
    width: "2px",
  },
  popoverContainer: {
    "& .MuiPaper-root": {
      backgroundColor: "transparent !important",
      boxShadow: "none",
    },
  },
  popoverContent: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1.5rem",
    padding: "10px",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
  },
  popoverLink: {
    textDecoration: "none",
    color: "#000",
    margin: "5px 0",
    "&:hover": {
      color: "#0073aa",
    },
  },
  loginButton: {
    color: "#ffffff",
    backgroundColor: "#0073aa",
    "&:hover": {
      color: "#e2f6ff",
      backgroundColor: "#005b87",
    },
  },
  authenticateContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      gap: "1rem",
    },
  },
  authenticateButtons: {
    padding: 0,
    "&:hover": {
      outline: "2px solid",
      textDecoration: "none",
    },
  },
  home: {
    display: "none",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: "block",
    },
  },
  shoppingBadge: {
    "& .MuiBadge-badge": {
      padding: "1px",
    },
  },
  profileIcon: {
    color: "white",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      color: "white",
      mixBlendMode: "difference",
    },
  },
  circularProgress: {
    width: "20px !important",
    height: "20px !important",
  },
}));
